import { RefObject, useState } from "react";
import { Search, X } from "lucide-react";
import { Button } from "@/components/ui/Button";

interface CommandPaletteInputProps {
  inputRef: RefObject<HTMLInputElement | null>;
  onSearch: (value: string) => void;
  onClear: VoidFunction;
}

export function CommandPaletteInput({
  inputRef,
  onSearch,
  onClear,
}: CommandPaletteInputProps) {
  const [value, setValue] = useState("");

  const handleClear = () => {
    setValue("");
    onClear();
  };

  const handleSearch = () => onSearch(value);

  return (
    <div className="flex items-center gap-3 border-b px-5 py-3.5">
      <Search
        className="text-action-disabled-content size-4.5 shrink-0"
        strokeWidth={2}
      />
      <input
        ref={inputRef}
        autoFocus
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            onSearch(value);
          }
        }}
        placeholder="Search patients or navigate..."
        className="flex-1 border-0 bg-transparent text-base leading-[1.4] font-medium outline-none"
      />
      {value && (
        <Button
          size="sm"
          color="secondary"
          icon={X}
          onClick={handleClear}
          className="text-action-disabled-content"
        />
      )}
      <Button size="md" icon={Search} onClick={handleSearch} />
    </div>
  );
}
